// XP Canjes Service — SOLO LECTURA en tiempo real
// Lee la colección xp_canjes de Firestore para alimentar el modal "Canjear XP".
// El frontend solo muestra; el descuento de XP y entrega del premio sigue ocurriendo
// en el backend vía POST /api/user/{uid}/xp/claim.
import { collection, onSnapshot, query } from 'firebase/firestore';
import { db } from './firebase';

const COLLECTION_PATH = 'xp_canjes';

/**
 * Suscribirse a la colección xp_canjes.
 * Filtra por activo === true y ordena por `orden` ascendente.
 *
 * Campos esperados por canje (todos opcionales salvo costo_xp):
 *   nombre, descripcion, costo_xp, tipo_premio, valor_premio,
 *   orden, limite_diario, limite_por_usuario, icono, color, etiqueta, activo
 *
 * @param {Function} callback - Recibe { canjes, total, error }
 * @returns {Function} - unsubscribe
 */
export const listenXpCanjes = (callback) => {
  const colRef = collection(db, COLLECTION_PATH);
  const q = query(colRef);

  const unsubscribe = onSnapshot(
    q,
    (snap) => {
      const all = [];
      snap.forEach((doc) => {
        const data = doc.data() || {};
        all.push({ id: doc.id, ...data });
      });
      const activos = all
        .filter((c) => c.activo === true)
        .sort((a, b) => (a.orden ?? 9999) - (b.orden ?? 9999));
      console.log(`[XP-CANJES] colección actualizada: ${all.length} docs, ${activos.length} activos`);
      callback({ canjes: activos, total: activos.length, error: null });
    },
    (error) => {
      console.log('[XP-CANJES] error leyendo colección:', error.message);
      callback({ canjes: [], total: 0, error: error.message });
    }
  );
  return unsubscribe;
};
